export default [{
        path: '/error-404',
        name: 'error-404',
        component: () =>
            import ('@/views/error/Error404.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            action: 'read',
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () =>
            import ('@/views/pages/authentication/Register.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('@/views/pages/authentication/Login.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
            redirectIfLoggedIn: true,
        },
    },
    {
        path: '/not-authorized',
        name: 'not-authorized',
        component: () =>
            import ('@/views/pages/authentication/NotAuthorized.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        },
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () =>
            import ('@/views/pages/authentication/ForgotPassword.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () =>
            import ('@/views/pages/authentication/ResetPassword.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        }
    },
    {
        path: '/enable-account',
        name: 'enable-account',
        component: () =>
            import ('@/views/pages/authentication/EnableAccount.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        }
    },
    {
        path: '/verify-email',
        name: 'verify-email',
        component: () =>
            import ('@/views/pages/authentication/VerifyEmail.vue'),
        meta: {
            layout: 'full',
            resource: 'Auth',
        }
    }
]